// extracted by mini-css-extract-plugin
export default {"action":"WarehouseActions_action__ty8Cg","actions":"WarehouseActions_actions__8pk-5"};